import { AnalyticsTypes } from './google-analytics';
import { get } from 'lodash';

export const attachPageCategory = (action, pageName) => {
    if (get(action, 'meta.analytics.type') === AnalyticsTypes.TrackEvent && !action.meta.analytics.category) {
        action.meta.analytics.category = pageName;
    }
};

export const pageCategoryMiddleware = pageName => {
    return () => next => action => {
        attachPageCategory(action, pageName);
        return next(action);
    };
};
